import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/AppShell";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import Today from "@/pages/Today";
import Discover from "@/pages/Discover";
import UserProfile from "@/pages/UserProfile";
import Messages from "@/pages/Messages";
import Conversation from "@/pages/Conversation";
import Moments from "@/pages/Moments";
import Communities from "@/pages/Communities";
import Learn from "@/pages/Learn";
import Profile from "@/pages/Profile";
import DateIdeas from "@/pages/DateIdeas";
import Premium from "@/pages/Premium";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import VouchesPending from "@/pages/VouchesPending";
import VouchSubmit from "@/pages/VouchSubmit";
import LicenseShare from "@/pages/LicenseShare";
import KindLedger from "@/pages/KindLedger";
import LedgerShare from "@/pages/LedgerShare";
import CrossedPaths from "@/pages/CrossedPaths";
import WeeklyWholesome from "@/pages/WeeklyWholesome";
import { InstallPWA } from "@/components/InstallPWA";
import Admin from "@/pages/Admin";

const Shell = ({ children }) => <AppShell>{children}</AppShell>;

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" toastOptions={{ style: { fontFamily: "Inter" } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/premium" element={<Premium />} />
          <Route path="/vouch/:token" element={<VouchSubmit />} />
          <Route path="/license/:licenseNo" element={<LicenseShare />} />
          <Route path="/ledger/:licenseNo" element={<LedgerShare />} />
          <Route path="/vouches" element={<ProtectedRoute><VouchesPending /></ProtectedRoute>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />

          <Route path="/onboarding" element={
            <ProtectedRoute>
              <Onboarding />
            </ProtectedRoute>
          } />

          <Route path="/app" element={<ProtectedRoute><Shell><Today /></Shell></ProtectedRoute>} />
          <Route path="/app/discover" element={<ProtectedRoute><Shell><Discover /></Shell></ProtectedRoute>} />
          <Route path="/app/user/:id" element={<ProtectedRoute><Shell><UserProfile /></Shell></ProtectedRoute>} />
          <Route path="/app/messages" element={<ProtectedRoute><Shell><Messages /></Shell></ProtectedRoute>} />
          <Route path="/app/messages/:id" element={<ProtectedRoute><Shell><Conversation /></Shell></ProtectedRoute>} />
          <Route path="/app/moments/:convId" element={<ProtectedRoute><Shell><Moments /></Shell></ProtectedRoute>} />
          <Route path="/app/communities" element={<ProtectedRoute><Shell><Communities /></Shell></ProtectedRoute>} />
          <Route path="/app/learn" element={<ProtectedRoute><Shell><Learn /></Shell></ProtectedRoute>} />
          <Route path="/app/profile" element={<ProtectedRoute><Shell><Profile /></Shell></ProtectedRoute>} />
          <Route path="/app/date-ideas" element={<ProtectedRoute><Shell><DateIdeas /></Shell></ProtectedRoute>} />
          <Route path="/app/ledger" element={<ProtectedRoute><Shell><KindLedger /></Shell></ProtectedRoute>} />
          <Route path="/app/paths" element={<ProtectedRoute><Shell><CrossedPaths /></Shell></ProtectedRoute>} />
          <Route path="/app/weekly" element={<ProtectedRoute><Shell><WeeklyWholesome /></Shell></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <InstallPWA />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
